module.exports = __webpack_public_path__ + "static/media/mood-board-header@2x.aae7d513.png";